import { motion } from "framer-motion";
import { Mail, ArrowRight } from "lucide-react";
import MovingBackground from "./MovingBackground";
import logoText from "@/assets/logo-text.png";

const ease = [0.16, 1, 0.3, 1] as const;

const ClosingSlide = ({ thumbnail }: { thumbnail?: boolean }) => (
  <div className="relative w-full h-full flex flex-col items-center justify-center bg-background overflow-hidden">
    <MovingBackground variant="orbs" />

    <div className="relative z-10 flex flex-col items-center text-center px-8 max-w-3xl">
      <motion.img
        src={logoText}
        alt="EastWest IT"
        className="mb-8"
        style={{ height: thumbnail ? "20px" : "clamp(30px, 4vw, 50px)" }}
        initial={thumbnail ? false : { opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease }}
      />

      <motion.h2
        className="font-display font-bold text-foreground mb-4"
        style={{ fontSize: thumbnail ? "1rem" : "clamp(1.5rem, 4vw, 3.5rem)" }}
        initial={thumbnail ? false : { opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.7, ease }}
      >
        Ready to <span className="text-gradient">Transform</span>?
      </motion.h2>

      <motion.p
        className="text-muted-foreground font-body mb-8 max-w-xl leading-relaxed"
        style={{ fontSize: thumbnail ? "0.5rem" : "clamp(0.9rem, 1.3vw, 1.15rem)" }}
        initial={thumbnail ? false : { opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6, ease }}
      >
        Let's discuss how AI can create measurable value for your organisation — governed, secure, and impactful.
      </motion.p>

      {!thumbnail && (
        <motion.div
          className="flex flex-col sm:flex-row items-center gap-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6, ease }}
        >
          <a
            href="https://eastwestit.dk/#contact"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-display font-semibold text-primary-foreground"
            style={{ background: "var(--gradient-primary)", boxShadow: "var(--accent-glow)" }}
          >
            <Mail size={18} />
            Get in Touch
            <ArrowRight size={16} />
          </a>
          <span className="text-muted-foreground text-sm">jesper@eastwestit.dk</span>
        </motion.div>
      )}

      {/* Decorative ring */}
      <motion.div
        className="absolute w-[500px] h-[500px] rounded-full border border-primary/10"
        style={{ top: "50%", left: "50%", marginTop: "-250px", marginLeft: "-250px" }}
        animate={{ rotate: 360, scale: [1, 1.05, 1] }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
      />
    </div>
  </div>
);

export default ClosingSlide;
